
import { AlertService } from "app/services/alertService"
import { Link } from 'react-router-dom';
import {
    Button,
    Grid,
    styled,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContentText,
    TextField
} from "@mui/material";
import { Span } from "app/components/Typography";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { TextValidator, ValidatorForm, SelectValidator } from "react-material-ui-form-validator";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import DialogContent from '@mui/material/DialogContent';
import { PickService } from "app/services/pick-service";
import LoadingModelComponent from "app/components/LoadingModelComponent";
import { OverrideActionService } from "app/services/override-action-service";
import moment from "moment";



const PikingOverride = ({ data }) => {



    const columns = [
        { field: 'orderNo', headerName: 'orderNo', width: 150 },
        { field: 'skuCode', headerName: 'skuCode', width: 150 },
        { field: 'skuDescription', headerName: 'sku Description', width: 150 },
        { field: 'subWarehouseCode', headerName: 'sub WarehouseCode', width: 230 },
        { field: 'isPickOverride', headerName: 'isPickOverride', width: 130 },
        { field: 'pickOverrideReason', headerName: 'pickOverrideReason', width: 230 },
        { field: 'systemGuidedLocationCode', headerName: 'system Location', width: 230 },
        { field: 'systemGuidedBarCode', headerName: 'system BarCode', width: 230 },
        { field: 'assignedQuantity', headerName: 'assignedQuantity', width: 130 },
        { field: 'actualPickedQty', headerName: 'actualPickedQty', width: 130 },
        { field: 'scannedByUser', headerName: 'scannedByUser', width: 230 },
        { field: 'scannedDate', headerName: 'Pick Date', width: 130, valueFormatter: params => { if (params?.value) return moment(params?.value).format("DD/MMM/yyyy hh:mm") } },
        { field: 'scannedLocationCode', headerName: 'scannedLocationCode', width: 130 },
        { field: 'scanAjexBarCode', headerName: 'scanAjexBarCode', width: 130 },
        { field: 'isPickComplete', headerName: 'isPickComplete', width: 130 },

        { field: 'isInventory', headerName: 'isInventory', width: 130 },

    ];
    const columnsPickOverrideAcction = [
        { field: 'id', headerName: 'Id', hide: true },
        { field: 'description', headerName: 'Description', width: 447 },
    ];
    const [ListOfOrderPick, setListOfOrderPick] = useState([]);
    const [IsLoaded, setIsLoaded] = useState(false);

    const [Open, setOpen] = useState(false);
    const [SelectedPickorderForOveridAcction, setSelectedPickorderForOveridAcction] = useState([]);


    const [PickOverrideActionList, setPickOverrideActionList] = useState([]);
    const [SelectedPickOverrideAction, setSelectedPickOverrideAction] = useState([]);
    const [Remarks, setRemarks] = useState('');
    const location = useLocation();//used to get data from previous page;

    // useEffect(() => {
    //     GetPickOverrid();
    // }, []);
    // const GetPickOverrid = () => {
    //     setIsLoaded(true);
    //     PickService
    //         .GetPickforPickOverride(location.state?.data?.id)
    //         .then(pick => {
    //             
    //             if (pick !== null) {
    //                 setListOfOrderPick(pick);
    //             }
    //             setIsLoaded(false);
    //         })
    //         .catch((err) => {
    //             console.log(err.message);
    //             setIsLoaded(false);
    //         });
    // }
    const GetPickOverrideList = () => {
        setIsLoaded(true);
        OverrideActionService
            .getAll()
            .then(users => { setPickOverrideActionList(users); setIsLoaded(false); })
            .catch((err) => { console.log(err.message); setIsLoaded(false); });
    }
    useEffect(() => {

        GetPickOverrideList();
    }, []);
    // const {
    //     OrderCode,
    //     containerNo,
    //     wayBillNo,
    // } = orderMaster;

    const navigate = useNavigate();
    const handlereset = (event) => {
        navigate("/outward/Picking/list");
    }




    function UpdateOutPickOverrideHandel() {

        if (SelectedPickorderForOveridAcction.length === 0) {
            AlertService.error(JSON.stringify('Please Select Overide Pick item '), { keepAfterRouteChange: true });
        }
        else {

            setOpen(true);

        }
    }
    function SelectedPickOverrideActionHandle(params) {

        setSelectedPickOverrideAction(params.row);
    }
    function handleRowClick(params) {

        // setSelectedPickOverrideAction(params.row);
        setSelectedPickorderForOveridAcction(params.row)
    }

    function ModelhandleClose(event, reason) {

        if (reason && reason == "backdropClick")
            return;
        setOpen(false);
    }


    function handleChangeRemarks(event, value) {

        setRemarks(event.target.value);
    }
    function ModelhandleOk() {


        var myArray = [];

        if (SelectedPickorderForOveridAcction.length === 0)
            AlertService.error('Select Pick List for Assign Piking override Action', { keepAfterRouteChange: true });
        else if (SelectedPickOverrideAction == undefined || SelectedPickOverrideAction == '')
            AlertService.error('Select Pick override Action', { keepAfterRouteChange: true });
        else if (Remarks === undefined || Remarks === '')
            AlertService.error('Select Remarks', { keepAfterRouteChange: true });
        else {

            for (let i = 0; i < SelectedPickorderForOveridAcction.length; i++) {
                //selectreceivingforPutawy[i].putAwayAssignedTo = userid;
                var UpdatePicker = { pickingId: 0, overrideActionId: 0, remarks: '' }
                UpdatePicker.pickingId = SelectedPickorderForOveridAcction[i].id;
                //UpdatePicker.isPickOverride = SelectedPickorderForOveridAcction[i].id;
                //UpdatePicker.pickOverrideReason = SelectedPickorderForOveridAcction[i].id;
                UpdatePicker.overrideActionId = SelectedPickOverrideAction.id;
                UpdatePicker.remarks = Remarks;
                myArray.push(UpdatePicker);
            }




            const response = PickService.PickoverrideAction(myArray).then(
                x => {
                    navigate("/outward/order/list");
                }

            ).catch((err) => {
                //AlertService.error(err.message, { keepAfterRouteChange: true });
                console.log(err.message);
            });
        }

    }
    return (

        <div>

            <Button color="primary" onClick={() => UpdateOutPickOverrideHandel()} >
                <Span sx={{ pl: 1, textTransform: "capitalize" }}>Pick Override Acction</Span>
            </Button>
            <div style={{ height: '300px', width: '100%' }}>
                <DataGrid
                    rows={data}
                    columns={columns}
                    density="compact"
                    //onRowClick={handleRowClick}
                    disableMultipleSelection={true}
                    pageSize={100}
                    checkboxSelection
                    rowsPerPageOptions={[100]}
                    pagination
                    onSelectionModelChange={(ids) => {
                        const selectedIDs = new Set(ids);
                        const selectedRows = data.filter((row) =>
                            selectedIDs.has(row.id),
                        );

                        setSelectedPickorderForOveridAcction(selectedRows)
                        console.log(selectedRows);
                    }}

                    components={{ Toolbar: GridToolbar }}
                />
                <Dialog open={Open} onClose={ModelhandleClose} disableEscapeKeyDown aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Pick Override Acction List</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Select Override Acction
                        </DialogContentText>
                        <div style={{ height: '250px', width: '450px' }}>

                            <DataGrid
                                rows={PickOverrideActionList}
                                density="compact"
                                columns={columnsPickOverrideAcction}
                                onRowClick={SelectedPickOverrideActionHandle}
                                pageSize={100}
                                rowsPerPageOptions={[100]}
                            />
                        </div>
                        <br></br>
                        <Grid item xs={16}>
                            <TextField
                                type="text"
                                size="small"

                                name="Remarks"
                                id="standard-basic"
                                value={Remarks}
                                onChange={handleChangeRemarks}
                                errorMessages={["this field is required"]}
                                label="Remarks"
                                validators={["required"]}
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="secondary" onClick={ModelhandleClose}>
                            Cancel
                        </Button>
                        <Button onClick={ModelhandleOk} color="primary">
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

        </div>

    );

}
export { PikingOverride };
